/* global MK, window, ASMIRA */
import { csrfToken } from 'mk/common/csrfToken';
import { detectDeviceOS } from 'mk/common/utils';
import { makeClientApiAuth } from 'mk/xhr/apiAuth';

export default function fakeContext() {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let deviceOS = detectDeviceOS(userAgent);

    return {
        isFake: true,
        requestUser: MK.requestUser,
        requestUserPermissions: MK.requestUserPermissions,
        requestUserSettings: MK.requestUserSettings,
        csrfToken: csrfToken(),
        apiAuth: makeClientApiAuth(),
        isAndroid: (deviceOS === 'Android'),
        isIOS: (deviceOS === 'iOS'),
    };
}
